import { useState } from "react";
import { formatINR, formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";
import EduSection from "@/components/EduSection";

const CROPS = [
  { key: "wheat",     label: "Wheat / गेहूँ",       yieldQt: 20, msp: 2275 },
  { key: "rice",      label: "Rice / धान",         yieldQt: 25, msp: 2300 },
  { key: "sugarcane", label: "Sugarcane / गन्ना",  yieldQt: 700, msp: 340 },
  { key: "maize",     label: "Maize / मक्का",      yieldQt: 22, msp: 2225 },
  { key: "mustard",   label: "Mustard / सरसों",    yieldQt: 12, msp: 5650 },
  { key: "cotton",    label: "Cotton / कपास",     yieldQt: 8,  msp: 7521 },
];

export default function CropYield() {
  const [acres, setAcres] = useState("5");
  const [crop, setCrop] = useState("wheat");
  const [yieldQt, setYieldQt] = useState("20");
  const [price, setPrice] = useState("2275");

  const A = Number(acres)||0, Y = Number(yieldQt)||0, P = Number(price)||0;
  const totalYield = A * Y;
  const revenue = totalYield * P;
  const rows = [
    ["Area", `${A} acres`],
    ["Crop", CROPS.find((c)=>c.key===crop)?.label || crop],
    ["Yield / acre", `${Y} quintal`],
    ["Price / quintal", formatINR(P)],
    ["Total Yield", `${formatNumber(totalYield)} quintal`],
    ["Est. Revenue", formatINR(revenue)],
  ];
  return (
    <div>
      <CalcPageHeader title="Crop Yield Estimator" description="Estimate total yield and revenue by crop, acreage and rate — with MSP presets." slug="crop-yield" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Field label="Land Area (acres)"><input data-testid="cy-acres" type="number" value={acres} onChange={(e)=>setAcres(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
              <Field label="Crop">
                <select data-testid="cy-crop" value={crop} onChange={(e)=>{setCrop(e.target.value); const c=CROPS.find(x=>x.key===e.target.value); if(c){setYieldQt(String(c.yieldQt));setPrice(String(c.msp));}}} className="w-full h-11 px-3 rounded-md border border-border bg-background text-sm outline-none focus:ring-2 focus:ring-primary/40">
                  {CROPS.map((c)=><option key={c.key} value={c.key}>{c.label}</option>)}
                </select>
              </Field>
              <Field label="Yield per acre (quintal)"><input data-testid="cy-yield" type="number" value={yieldQt} onChange={(e)=>setYieldQt(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
              <Field label="Price ₹/quintal" hint="MSP or market rate"><input data-testid="cy-price" type="number" value={price} onChange={(e)=>setPrice(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            </div>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Crop Yield" slug="crop-yield" highlight={{ label: "Est. Revenue", value: formatINR(revenue), sub: `${formatNumber(totalYield)} quintal total` }} rows={rows} note="Defaults are approximate all-India yields & MSPs. Adjust for your region." />
        </div>
      </div>
      <EduSection howItWorks={<p>Total yield = Area × Yield/acre. Revenue = Total yield × Price. Yields and MSPs vary substantially by state, irrigation and season — override defaults as needed.</p>} related={["land-converter","warehouse-rent"]} />
    </div>
  );
}
